import api from "../..";
import type {
  GetGoldenChallengeByIdParams,
  GetGoldenChallengeChainsParams,
  GetGoldenChallengeChainByIdParams,
  GetGoldenChallengesParams,
  GoldenChallenge,
  GoldenChallengeChain,
  GoldenChallengeChainListResult,
  GoldenChallengeListResult,
} from "./types";

const normalizeList = <T>(payload: unknown): { items: T[]; count: number } => {
  if (Array.isArray(payload)) {
    return { items: payload as T[], count: payload.length };
  }

  if (payload && typeof payload === "object") {
    const envelope = payload as {
      results?: T[];
      data?: unknown;
      count?: number;
    };

    if (Array.isArray(envelope.results)) {
      return {
        items: envelope.results,
        count: envelope.count ?? envelope.results.length,
      };
    }

    if (Array.isArray(envelope.data)) {
      return {
        items: envelope.data as T[],
        count: envelope.count ?? envelope.data.length,
      };
    }

    if (envelope.data && typeof envelope.data === "object") {
      return normalizeList<T>(envelope.data);
    }
  }

  return { items: [], count: 0 };
};

const normalizeResource = (payload: unknown): GoldenChallenge | null => {
  if (!payload || typeof payload !== "object") return null;

  const envelope = payload as { data?: GoldenChallenge; id?: number };

  if (envelope.data && typeof envelope.data === "object") return envelope.data;
  if (typeof envelope.id === "number") return payload as GoldenChallenge;

  return null;
};

export const getGoldenChallenges = async ({ params }: GetGoldenChallengesParams = {}): Promise<GoldenChallengeListResult> => {

  return await api.get(`/admin/golden-challenges/`, params ? { params } : {})
  .then((res) => normalizeList<GoldenChallenge>(res.data))
  .catch(() => ({ items: [], count: 0 }));
};

export const getGoldenChallengeChains = async ({ params }: GetGoldenChallengeChainsParams = {}): Promise<GoldenChallengeChainListResult> => {

  return await api.get(`/admin/challenges/chains/`, params ? { params } : {})
  .then((res) => normalizeList<GoldenChallengeChain>(res.data))
  .catch(() => ({ items: [], count: 0 }));
};

export const getGoldenChallengeById = async ({ id }: GetGoldenChallengeByIdParams): Promise<GoldenChallenge | null> => {

  return await api.get(`/admin/golden-challenges/${id}/`)
  .then((res) => normalizeResource(res.data))
  .catch(() => {return null});
};

export const getGoldenChallengeChainById = async ({ id }: GetGoldenChallengeChainByIdParams): Promise<GoldenChallengeChain | null> => {

  return await api.get(`/admin/challenges/chains/${id}/`)
  .then((res) => {
    const payload = res.data;
    if (!payload || typeof payload !== "object") return null;
    const envelope = payload as { data?: GoldenChallengeChain; id?: number };
    if (envelope.data && typeof envelope.data === "object") return envelope.data;
    if (typeof envelope.id === "number") return payload as GoldenChallengeChain;
    return null;
  })
  .catch(() => null);
};
